<template>
  <div>
    <div id="map" :style="'width: 100%; height: ' + mapdata.height"></div>
  </div>
</template>
  <script>
export default {
  name: "maps",
  props: {
    mapdata: {
      type: Object
    },
    mapInfo: {
      type: Array
    }
  },
  data() {
    return {
      dataByColor: [
        {
          name: "杭州市",
          value: 1
        },
        {
          name: "宁波市",
          value: 1
        },
        {
          name: "温州市",
          value: 1
        },
        {
          name: "嘉兴市",
          value: 1
        },
        {
          name: "湖州市",
          value: 1
        },
        {
          name: "绍兴市",
          value: 1
        },
        {
          name: "金华市",
          value: 1
        },
        {
          name: "衢州市",
          value: 1
        },
        {
          name: "舟山市",
          value: 1
        },
        {
          name: "台州市",
          value: 1
        },
        {
          name: "丽水市",
          value: 1
        }
      ],
      tooltip: [
        {
          lng: "120.153576",
          lat: "30.287459",
          name: "杭州市",
          info:
            '杭州</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>1406077</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>379046</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>980610</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>44176</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>63</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>423</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>1565</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>112</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>82</strong></font><br/>'
        },
        {
          lng: "121.549792",
          lat: "29.868388",
          name: "宁波市",
          info:
            '宁波</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>693933</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>280686</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>355436</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>57263</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>52</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>148</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>213</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>103</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>32</strong></font><br/>'
        },
        {
          lng: "120.846891",
          lat: "28.280824",
          name: "温州市",
          info:
            '温州</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>860871</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>196772</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>597684</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>66204</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>23</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>10</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>60</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>76</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>42</strong></font><br/>'
        },
        {
          lng: "120.750865",
          lat: "30.762653",
          name: "嘉兴市",
          info:
            '嘉兴</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>392182</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>133208</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>246385</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>12470</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>24</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>2</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>35</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>38</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>20</strong></font><br/>'
        },
        {
          lng: "120.102398",
          lat: "30.867198",
          name: "湖州市",
          info:
            '湖州</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>190100</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>77017</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>111296</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>1484</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>26</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>59</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>188</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>12</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>18</strong></font><br/>'
        },
        {
          lng: "120.582112",
          lat: "29.997117",
          name: "绍兴市",
          info:
            '绍兴</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>384730</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>131152</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>187819</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>65500</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>19</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>3</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>184</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>16</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>37</strong></font><br/>'
        },
        {
          lng: "119.649506",
          lat: "29.089524",
          name: "金华市",
          info:
            '金华</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>810360</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>135734</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>653409</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>21016</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>33</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>48</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>51</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>33</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>36</strong></font><br/>'
        },
        {
          lng: "118.87263",
          lat: "28.941708",
          name: "衢州市",
          info:
            '衢州</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>83437</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>24556</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>55537</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>3277</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>31</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>3</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>14</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>7</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>12</strong></font><br/>'
        },
        {
          lng: "122.106863",
          lat: "30.016028",
          name: "舟山市",
          info:
            '舟山</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>28277</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>10709</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>17408</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>121</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>26</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>0</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>6</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>1</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>6</strong></font><br/>'
        },
        {
          lng: "121.428599",
          lat: "28.661378",
          name: "台州市",
          info:
            '台州</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>490037</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>140643</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>307228</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>42021</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>40</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>6</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>20</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>62</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>17</strong></font><br/>'
        },
        {
          lng: "119.921786",
          lat: "28.451993",
          name: "丽水市",
          info:
            '丽水</strong></font><br/><font color="#ffffff">合计:</font><font color="#1affd1"><strong>124071</strong></font><br/><font color="#ffffff">专利:</font><font color="#1affd1"><strong>38542</strong></font><br/><font color="#ffffff">商标:</font><font color="#1affd1"><strong>84596</strong></font><br/><font color="#ffffff">著作权:</font><font color="#1affd1"><strong>836</strong></font><br/><font color="#ffffff">地理标志:</font><font color="#1affd1"><strong>44</strong></font><br/><font color="#ffffff">植物新品种:</font><font color="#1affd1"><strong>18</strong></font><br/><font color="#ffffff">集成电路布图设计:</font><font color="#1affd1"><strong>11</strong></font><br/><font color="#ffffff">商业秘密:</font><font color="#1affd1"><strong>2</strong></font><br/><font color="#ffffff">其他:</font><font color="#1affd1"><strong>22</strong></font><br/>'
        }
      ],
      areaCode: "330000",
      oldAreaCode: "330000",
      mapjson: {},
      title: "浙江",
      oldAreaName: "浙江",
      childNum: null
    };
  },
  computed: {
    isTooptip() {
      if (this.areaCode.substring(4, 6) != "00") {
        return false;
      } else {
        return true;
      }
      // return this.areaCode.includes("00");
    }
  },
  watch: {
    // areaCode: {
    //   handler(val, oldVal) {
    //     if (val != oldVal && val) {
    //       this.getMapJson();
    //       console.log(this.title);
    //       this.$emit("changeTitle", this.title.substring(0, 2), this.areaCode);
    //     }
    //   },
    //   immediate: true
    // }
    mapInfo: {
      handler(val, oldVal) {
        if (val != oldVal && val) {
          this.getMapJson();
        //   console.log(this.title);
        //   this.$emit("changeTitle", this.title.substring(0, 2), this.areaCode);
        }
      },
      immediate: true,
      deep:true
    }
  },
  mounted() {
    // this.getMapJson();
  },
  methods: {
    province() {
      if (this.childNum) {
        this.areaCode = "330000";
        this.title = "";
      } else {
        this.areaCode = this.oldAreaCode.substring(0, 4) + "00";
        this.oldAreaCode = this.areaCode;
        this.childNum = 1;
        this.title = this.oldAreaName
          .replace("市", "")
          .replace("区", "")
          .replace("县", "");
      }
    },
    async getMapJson() {
      const res = await this.$axios.get(`./mapJson/330000.json`);
      res.data.features.map(item => {
        item.properties.code = item.id || item.properties.code;
        return item;
      });
      this.mapjson = res.data;
      if (this.areaCode == "330000") {
        this.dataByColor = []
        this.mapInfo.forEach(item => {
          this.dataByColor.push({
            name: item.areaName,
            value: 0,
            number:item.count
          });
        }); 
        // this.dataByColor = [
        //   {
        //     name: "杭州市",
        //     value: 0,
        //     number:10
        //   },
        //   {
        //     name: "宁波市",
        //     value: 0,
        //     number:12
        //   },
        //   {
        //     name: "温州市",
        //     value: 0
        //   },
        //   {
        //     name: "嘉兴市",
        //     value: 0
        //   },
        //   {
        //     name: "湖州市",
        //     value: 0
        //   },
        //   {
        //     name: "绍兴市",
        //     value: 0
        //   },
        //   {
        //     name: "金华市",
        //     value: 0
        //   },
        //   {
        //     name: "衢州市",
        //     value: 0
        //   },
        //   {
        //     name: "舟山市",
        //     value: 0
        //   },
        //   {
        //     name: "台州市",
        //     value: 0
        //   },
        //   {
        //     name: "丽水市",
        //     value: 0
        //   }
        // ];
      } else {//当前只使用省的数据展示
        // this.dataByColor = res.data.features.map((item, index) => {
        //   item.name = item.properties.name;
        //   item.value = index % 3;
        //   return item;
        // });
      }

      this.$nextTick(() => {
        this.$emit("getNumber", this.areaCode);
        this.map();
      });
    },
    map() {
      let mapset = this.$echarts.init(document.getElementById("map"));
      mapset.showLoading();
      var that = this;
      mapset.hideLoading();
      that.$echarts.registerMap("HK", this.mapjson);
      var option = {
        title: {},
        tooltip: {
        //   show: this.isTooptip,
          show: false,//将移入的弹框隐藏
          trigger: "item",
          enterable: true,
          padding: [30, 50],
          className: "hoverimage",
          position: function(pos) {
            return pos;
          },
          formatter: function(res) {
            var html = `<div style="
              position: absolute;
              background: rgba(0, 9, 56, 0.88);
    
              border-radius: 0px;
              box-shadow: 14px 14px 5px rgba(18, 35, 60, 0);
              "><div style="
                  margin: 10px 20px 10px 20px;
                  min-width: 250px;
                  word-wrap: break-word;
                  display: inline-block;
                  text-align: left;
                  text-overflow: ellipsis;
                  font-family: Microsoft Yahei;
                  color: #FFFFFF;
                  font-size: 18px;
                  line-height: 1.7;">`;
            that.mapInfo.forEach(item => {
              if (item.areaName == res.name.slice(0, res.name.length - 1)) {
                html += `<font color="#ffffff">${res.name}</font><font color="#1affd1"></font><br/>`;
                item.data.forEach(e => {
                  html += `<font color="#ffffff">${
                    e.name
                  }：</font><font color="#1affd1"><strong>${
                    e.value
                  }</strong></font>${
                    e.unit
                      ? `<font color="#1affd1"><strong>${e.unit}</strong></font>`
                      : ""
                  }<br/>`;
                });
              }
            });
            html += "</div></div>";
            return html;
          }
        },
        series: [
          {
            name: name + "分布图",
            type: "map",
            mapType: "HK", // 自定义扩展图表类型
            zoom: 1.2, //当前视角的缩放比例
            roam: false, //是否开启平游或缩放
            scaleLimit: {
              //滚轮缩放的极限控制
              min: 1,
              max: 10
            },
            aspectScale: 0.9,
            selectedMode: false,
            itemStyle: {
              normal: {
                label: {
                  show: true, //选中状态是否显示省份名称
                  color: "blue",
                  fontSize: 22,
                  fontFamily: "宋体",
                  formatter: function(params) {
                    return `${params.name}\n(${params.data.number || 0 })`;
                  }
                },

                // shadowColor: "rgba(0, 0, 0, 0.8)",
                // shadowBlur: 100,
                areaColor: "#0273c4",
                borderWidth: 1,
                borderColor: "rgb(143, 230, 243)"
              },
              emphasis: {
                areaStyle: {
                  color: "#4eacfb" //选中状态的地图板块颜色
                }
              }
            },
            data: that.dataByColor
          }
        ],
        visualMap: {
          show: this.mapdata.visual ? this.mapdata.visual : false,
          formatter: function() {
            return ""; // 范围标签显示内容。
          },
          left: "right",
          text: ["高", "低"],
          min: 0,
          max: 3,
          textStyle: {
            color: "#fff"
          },
          inRange: {
            color: [
              "rgb(17,172,218)",
              "rgb(11,128,218)",
              "rgb(8,108,218)",
              "rgb(0,48,218)"
            ]
          }
        }
      };
      mapset.setOption(option);
      // var hourIndex = 0;
      // //   var fhourTime = null;
      //   var fhourTime =
      // setInterval(function () {
      //   mapset.dispatchAction({
      //     type: "downplay",
      //     seriesIndex: 0,
      //   });
      //   mapset.dispatchAction({
      //     type: "highlight",
      //     seriesIndex: 0,
      //     dataIndex: hourIndex,
      //   });
      //   mapset.dispatchAction({
      //     type: "showTip",
      //     seriesIndex: 0,
      //     dataIndex: hourIndex,
      //   });
      //   hourIndex++;
      //   if (hourIndex > option.series[0].data.length - 1) {
      //     hourIndex = 0;
      //   }
      // }, 3000);
      //   mapset.on("mouseover", function(params) {
      //     if (params.componentType == "geo") {
      //       if (params.name != undefined) {
      //         mapset.dispatchAction({
      //           type: "downplay"
      //         });
      //       }
      //     }
      //   });
      //   if (this.mapdata.IsClick) {
      //     mapset.on("click", function(params) {
      //       window.open(
      //         "/index_area?areaName=" + params.data.name.replace("市", " ")
      //       );
      // // that.title = params.name
      // //   .replace("市", "")
      // //   .replace("区", "")
      // //   .replace("县", "");
      // that.mapjson.features.forEach((item) => {
      //   console.log('fffffffffffffffffff')
      //   if (item.properties.name == params.name) {
      //     if (item.properties.code) {
      //       window.open('/comtable?areadName=' + params.name)
      //     }
      //   }
      // });
      //     });
      //   }
    }
    // },
  }
};
</script>
  <style scoped>
.popupContent {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

/* .tooltipimg{
    background:url(../assets/img/dataVindex7.png)no-repeat center center;
    background-size: 100% 100%;
    border: 0 !important;
    background-color: unset !important;
  } */
</style>